import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.headerHtml)?_c('div',{ref:"customHeader",domProps:{"innerHTML":_vm._s(_vm.headerHtml)}}):_vm._e(),_c(VMain,[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }